import type { CreateSlice } from './index'

export interface DebugState {
    isDebugToolsEnabled: boolean
    toggleDebugTools: () => void
}

export const createDebugSlice: CreateSlice<DebugState> = (set, get) => ({
    isDebugToolsEnabled: false,
    toggleDebugTools: () => {
        const currentState = get().isDebugToolsEnabled
        const newState = !currentState
        console.log(`Debug tools ${newState ? 'enabled' : 'disabled'}`)
        set({ isDebugToolsEnabled: newState })
    },
})
